import { render, staticRenderFns } from "./PostPriceSettings.vue?vue&type=template&id=77fa5a18&scoped=true&"
import script from "./PostPriceSettings.vue?vue&type=script&lang=ts&"
export * from "./PostPriceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fa5a18",
  null
  
)

export default component.exports